import logger from './logger';
import getElementSelectors from './getElementSelectors';
import getCurrentGameSelected from './currentGameSelected';
import { getGameLaunchUrl } from '../../entities/gameLauncherUrl';
import { GameLaunchConfig } from '../types/SwipeSDKConfigType';

export const showLoader = (): void => {
  const { loader__iconId } = getElementSelectors();
  if (loader__iconId) {
    loader__iconId.style.display = 'block';
  }
};

export const hideLoader = (): void => {
  const { loader__iconId } = getElementSelectors();
  if (loader__iconId) {
    loader__iconId.style.display = 'none';
  }
};

export const showError = (
  message: string,
  error: Record<string, string> | unknown = {},
): void => {
  const { swipeErrorMsg } = getElementSelectors();
  if (swipeErrorMsg) {
    swipeErrorMsg.style.display = 'block';
  }
  logger.error(message, { error });
};

export const generateGameLaunchUrl = async (
  gameLaunchConfig: GameLaunchConfig,
  otp: string,
): Promise<string> => {
  const { currentGameId } = getCurrentGameSelected();
  return getGameLaunchUrl(gameLaunchConfig, currentGameId, otp);
};
